// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component, Prop } from 'vue-property-decorator';
import { AbstractModuleUi } from '../_abstract/ui';
import { EmbedVersion } from './Embed.contracts';
import { EmbedIframeUi, EmbedPdfUi, EmbedTwitterUi, EmbedVideoUi, EmbedYouTubeUi, EmbedVideoSwitchUi } from './versions/ui';
import { ImageRatio } from '../_contracts';
/**
 * Registry that binds the EmbedVersion with the applicable UI component.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
const embedVersionUiComponentRegistry = {
    [EmbedVersion.Iframe]: EmbedIframeUi,
    [EmbedVersion.YouTube]: EmbedYouTubeUi,
    [EmbedVersion.PDF]: EmbedPdfUi,
    [EmbedVersion.Twitter]: EmbedTwitterUi,
    [EmbedVersion.Video]: EmbedVideoUi,
    [EmbedVersion.VideoSwitch]: EmbedVideoSwitchUi
};
/**
 * Component capable of rendering the `EmbedModule`'s contents.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
let EmbedModuleUi = class EmbedModuleUi extends AbstractModuleUi {
    constructor() {
        super(...arguments);
        /**
         * @inheritDoc
         */
        this.imageRatios = {
            desktop: ImageRatio.Tile,
            mobile: ImageRatio.Tile
        };
    }
    /**
     * Vue component that should be used to render the module's content.
     */
    get component() {
        if (!(this.module.version in embedVersionUiComponentRegistry)) {
            this.onError(`EmbedModuleUi.[get]component(): There's no UI component for the given module version!\nFull [this.module] object: ${JSON.stringify(this.module)}`);
            return undefined;
        }
        return embedVersionUiComponentRegistry[this.module.version];
    }
    get parentTitle() {
        return this.parent ? this.parent.get('title') : undefined;
    }
    get publicationDate() {
        return this.parent ? this.parent.get('publicationDate') : undefined;
    }
    get properties() {
        return {
            ...(this.module.version === EmbedVersion.Video && this.parent
                ? { videoAdsTag: this.parent.get('properties').videoAdsTag }
                : {}),
            ...([EmbedVersion.YouTube, EmbedVersion.Video].includes(this.module.version) && this.parent
                ? { origin: this.parent.get('properties').site.address }
                : {})
        };
    }
};
__decorate([
    Prop({
        type: Object,
        required: false,
        default: null
    })
], EmbedModuleUi.prototype, "pdfService", void 0);
__decorate([
    Prop({
        type: Object,
        required: true
    })
], EmbedModuleUi.prototype, "siteService", void 0);
EmbedModuleUi = __decorate([
    Component({
        name: 'EmbedModuleUi',
        async created() {
            if (!this.module.content.thumbnail || Array.isArray(this.module.content.thumbnail)) {
                this.module.content.thumbnail = undefined;
            }
            if (!this.module.content.video || Array.isArray(this.module.content.video)) {
                this.module.content.video = undefined;
            }
            if (this.module.version === EmbedVersion.Twitter) {
                this.onReady();
            }
        },
        template: `
    <section class="module" :class="[loadingClass, versionClass]">
    <component v-if="component" :is="component" @ready="onReady"
               v-bind="{ ...module.content, relatedService, windowService, pdfService, siteService, isLoading,
               isLazy: module.isLazyLoaded, isMobile, shareService, imageRatio, publicationDate, parentTitle, ...properties }"/>
    </section>
  `
    })
], EmbedModuleUi);
export { EmbedModuleUi };
